import React from "react";
import { Redirect } from "react-router-dom";

export default function LaunchToAdminDashboard() {
  return <Redirect to="/db/admin/dashboard" />;
}
